
import RoomObjectDisplayer from '@/components/room/image-or-video-displayer/RoomObjectDisplayer.vue';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import UserIcon from './users/UserIcon.vue';
import {
  getCurrentRoom,
  getCoordinatesPositionWithoutScale,
  getEventMouseOrTouchXY,
  isGuest,
  uploadFile,
  isAdmin,
} from '@/utils/functions';
import Whiteboard from '@/components/room/whiteboard/Whiteboard.vue';
import {
  DEFAULT_SCREEN_SHARE_SCOPE,
  MAX_AVATAR_WIDTH_AND_HEIGHT,
  NO_SOUND_THRESHOLD_DISTANCE,
  UPLOAD_IMAGE_ERROR,
  statusList,
} from '@/utils/constants';
import SetPasswordPopup from '@/components/popup/room/SetPasswordPopup.vue';
import PasswordNeededPopup from '@/components/popup/room/PasswordNeededPopup.vue';
import ImageUploadPopup from '@/components/popup/room/ImageUploadPopup.vue';
import MessagePopup from '@/components/popup/common/MessagePopup.vue';
import LoadingPopup from '@/components/popup/room/LoadingPopup.vue';
import { DataService } from '@/service/DataService';
import ToolsPanel from '@/components/room/tools-panel/ToolsPanel.vue';
import FloorPlanSettingsPopup from '@/components/popup/room/FloorPlanSettingsPopup.vue';
import GeneralSettingsPopup from '@/components/popup/common/GeneralSettingsPopup.vue';
import UserMenu from '@/components/room/users/UserMenu.vue';
import RoomsMemberList from '@/components/room/rooms-list/RoomsMemberList.vue';
import StatusIcon from '@/components/room/users/StatusIcon.vue';
import RoomsMemberListItem from './rooms-list/RoomsMemberListItem.vue';
import SubRoomPresenter from './SubRoomPresenter.vue';
import RoomMap from './RoomMap.vue';
import {
  CoordinatesPosition,
  HTMLElementWithPosition,
  ImageWithDimensions,
  RoomSpace,
  Room,
  User,
  VolumeModes,
  SettingsSnapshot,
  UserRoomStateData,
  UserRoomState,
  RoomObject,
  SubRoom,
  DesktopRoomObject,
  GetScheduleResponse,
  CustomModes,
  NotificationModes,
  BoundingPosition,
  MessageHistory,
  GeneralSettingsSnapshot,
  UserProperties,
  StatusItem,
  RoomActivitiesManager,
} from '@/utils/models';
import ImagePreviewPopup from '@/components/popup/room/ImagePreviewPopup.vue';
import { zawaroom } from '@/utils/models';
import ToastKnockedUser from '@/components/utils/ToastKnockedUser.vue';
import 'iscroll';
import BoardSettingPopup from '../popup/room/BoardSettingPopup.vue';
import ConnectionDebugger from '../utils/ConnectionDebugger.vue';
import { RoomConnectionManager, UpdateConnectionEventArgs } from '@/service/RoomConnectionManager';
import UserScheduleDisplayer from './users/UserScheduleDisplayer.vue';
import ToastWithButtonPopup from '../popup/common/ToastWithButtonPopup.vue';
import MessageEditorDisplayer from '@/components/room/users/MessageEditorDisplayer.vue';
import StatusSetPanel from '@/components/room/users/StatusSetPanel.vue';

import PictureInPicture from '../utils/PictureInPicture.vue';
import { IScrollPinchInOutAddon } from '@/utils/iscroll-pinch-in-out-addon';
import LeaveRoomPopup from '../popup/room/LeaveRoomPopup.vue';
import RoomObjectMenu from './image-or-video-displayer/RoomObjectMenu.vue';
import { Debouncer } from '@/utils/debouncer';

/* eslint-disable @typescript-eslint/no-var-requires */
const enteringSoundFile = require('../../assets/sound/notification_sound.mp3');
const bellRingSoundFile = require('../../assets/sound/japanese_school_bell.mp3');
// const bgmSoundFile = require("../../assets/sound/bgm01.mp3");
const knockSoundFile = require('../../assets/sound/knock02.mp3');
// const openDoorSoundFile = require('../../assets/sound/open-door.mp3');
const openDoorSoundFile = require('../../assets/sound/doorclose03.mp3');
const messageSoundFile = require('../../assets/sound/message-notification.mp3');
const crossSoundFile = require('../../assets/sound/slipper-sound-short.mp3');

@Component({
  components: {
    ToastKnockedUser,
    ImagePreviewPopup,
    FloorPlanSettingsPopup,
    ToolsPanel,
    LoadingPopup,
    PasswordNeededPopup,
    SetPasswordPopup,
    ImageUploadPopup,
    GeneralSettingsPopup,
    MessagePopup,
    RoomObjectDisplayer,
    Whiteboard,
    UserIcon,
    UserMenu,
    RoomsMemberList,
    StatusIcon,
    RoomsMemberListItem,
    SubRoomPresenter,
    BoardSettingPopup,
    ConnectionDebugger,
    UserScheduleDisplayer,
    MessageEditorDisplayer,
    RoomMap,
    PictureInPicture,
    StatusSetPanel,
    LeaveRoomPopup,
    RoomObjectMenu,
  },
})
export default class RoomMain extends Vue {
  @Prop() dataService!: DataService;
  @Prop() space!: RoomSpace;
  @Prop() room!: Room;

  toggleEditorFromUserIcon = false;
  localIsEditingUserMessage: boolean = false;
  isShowStatusSelector = false;
  list: StatusItem[] = [];
  selectingIndex = 0;

  iScrollTouchScreenAddon = new IScrollPinchInOutAddon();
  isFromToolsPanel = false;
  logManager = new RoomActivitiesManager();

  /**
   * 【デモサイト用】
   * 退出確認ポップアップの表示
   */
  leavePopupVisible = false;
  isObjectHover: boolean = false;
  isObjectMenuHover: boolean = false;
  private leaveTimer: any = 0;
  private lastPointerPos: CoordinatesPosition = { x: 0, y: 0 };
  private hoverTimer: any = 0;
  private positionDebouncer!: Debouncer;
  private objectSizeDebouncer!: Debouncer;
  private videoSizeDebouncer!: Debouncer;

  get isShowEditor(): boolean {
    return this.$store.state.isShowEditor ?? false;
  }
  get currentStatusIndex(): number {
    const currentStatus = this.userParticipantData?.userState.status;
    if (!currentStatus) {
      return 0;
    }
    return this.list.findIndex((item) => item.id === currentStatus);
  }
  get urlPosition(): CoordinatesPosition | undefined {
    const urlPositionQuery = {
      x: this.$route.query.x,
      y: this.$route.query.y,
    };
    if (urlPositionQuery && typeof urlPositionQuery.x === 'string' && typeof urlPositionQuery.y === 'string') {
      return {
        x: Number(urlPositionQuery.x),
        y: Number(urlPositionQuery.y),
      };
    }
  }
  get status(): string {
    return this.userParticipantData?.userState.status ?? '';
  }
  get statusStyleByUserIcon(): any {
    if (!this.userParticipantData) {
      return {};
    }
    const contextMenuSize = { width: 200, height: 285 };
    const targetBounding: BoundingPosition = {
      ...this.userParticipantData.userState.position,
      width: MAX_AVATAR_WIDTH_AND_HEIGHT,
      height: MAX_AVATAR_WIDTH_AND_HEIGHT,
    };
    return this.calcContextMenuPosition(contextMenuSize, targetBounding);
  }
  get objectMenuStyle(): any {
    if (!this.retrieveEnteredRoomObject) {
      return {};
    }
    const contextMenuSize = { width: 200, height: 35 };
    const target = this.retrieveEnteredRoomObject;
    let targetW: number;
    let targetH: number;
    if (target.objectType === 'image' || target.props.boardType === 'image') {
      targetW = target.width * (target.size / target.height);
      targetH = target.size;
    } else if (target.objectType === 'share screen') {
      const vel = (target as DesktopRoomObject)?.createdUserParticipant?.desktopTrack?.el as HTMLVideoElement;
      const vwidth = vel?.videoWidth || 1;
      const vheight = vel?.videoHeight || 1;
      targetW = vwidth * (target.size / vheight);
      targetH = target.size;
    } else {
      targetW = target.width;
      targetH = target.height;
    }
    const targetBounding: BoundingPosition = {
      ...target.position,
      width: targetW,
      height: targetH,
    };
    return this.calcContextMenuPosition(contextMenuSize, targetBounding, true);
  }
  get canEdit(): boolean {
    const enteredLoadedImage = this.loadedImages.find((image) => image.id === this.enteredRoomObject?.id) || null;
    return enteredLoadedImage ? enteredLoadedImage.createdUserId === this.user.id : false;
  }
  get retrieveEnteredRoomObject(): RoomObject | DesktopRoomObject | null {
    const bothObjects = [
      ...(this.loadedImages as Array<RoomObject>),
      ...(this.shareScreens as Array<DesktopRoomObject>),
    ];
    return bothObjects.find((o) => o.id === this.enteredRoomObject?.id) || null;
  }
  get version(): string {
    return this.$store.state.version ?? 'version';
  }
  selectedStateForMenu: UserRoomStateData | null = null;
  get userMenuStyle(): any {
    if (!this.selectedStateForMenu) {
      return {};
    }
    const contextMenuSize = { width: 200, height: 226 };
    const targetBounding: BoundingPosition = {
      ...this.selectedStateForMenu.userState.position,
      width: MAX_AVATAR_WIDTH_AND_HEIGHT,
      height: MAX_AVATAR_WIDTH_AND_HEIGHT,
    };
    return this.calcContextMenuPosition(contextMenuSize, targetBounding);
  }
  onPointerLeaveClearObject(roomObject: RoomObject | DesktopRoomObject | null = null) {
    clearTimeout(this.leaveTimer);
    clearTimeout(this.hoverTimer);
    this.leaveTimer = setTimeout(() => {
      this.isObjectHover = false;
      this.$store.commit('setIsRoomObjectHover', false);
      this.isObjectMenuHover = false;
      this.$store.commit('setIsRoomObjectMenuHover', false);
      if (roomObject && this.enteredRoomObject?.id === roomObject.id) {
        this.enteredRoomObject = null;
      }
    }, 500);
  }
  onPointerEnterSetObject(ev: PointerEvent, roomObject?: RoomObject | DesktopRoomObject) {
    clearTimeout(this.leaveTimer);
    this.isObjectHover = true;
    this.$store.commit('setIsRoomObjectHover', true);
    if (roomObject) {
      this.enteredRoomObject = roomObject;
    }
    this.onPointerMove(ev);
  }
  onPointerMove(ev: PointerEvent) {
    if (!this.isObjectHover || this.isObjectMenuHover) {
      return;
    }
    clearTimeout(this.hoverTimer);
    const { x, y } = ev;
    this.lastPointerPos.x = x;
    this.lastPointerPos.y = y;
    this.hoverTimer = setTimeout(() => {
      if (this.lastPointerPos.x === x && this.lastPointerPos.y === y) {
        this.isObjectMenuHover = true;
        this.$store.commit('setIsRoomObjectMenuHover', true);
      }
    }, 300);
  }
  private calcContextMenuPosition(
    contextMenuSize: { width: number; height: number },
    targetBoundingPosition: BoundingPosition,
    isTargetRoomObject?: boolean,
  ) {
    const scale = this.scale;
    let styles: any = {
      transform: 'scale(' + scale + ')',
    };
    if (!targetBoundingPosition) {
      return {
        ...styles,
        'transform-origin': '0 0',
        top: 200 + 'px',
        left: 200 + 'px',
      };
    }
    const targetPos = targetBoundingPosition;
    const scaledMenuSize = {
      width: contextMenuSize.width * scale,
      height: contextMenuSize.height * scale,
    };
    const viewportRect = this.viewportRect;
    const margin = 20 * scale;
    let origin: string;
    if (isTargetRoomObject) {
      // targetがroomObjectの場合
      if (viewportRect.right <= targetPos.x + targetPos.width / 2 + scaledMenuSize.width / 2) {
        // 通常横範囲より右にあるとき左側に表示
        styles.left = viewportRect.right + 'px';
        styles.transform = 'translateX(-100%) scale(' + scale + ')';
        origin = 'right ';
      } else if (viewportRect.left >= targetPos.x + targetPos.width / 2 - scaledMenuSize.width / 2) {
        // 通常横範囲より左にあるとき右側に表示
        styles.left = viewportRect.left + 'px';
        styles.transform = 'translateX(0%) scale(' + scale + ')';
        origin = 'left ';
      } else {
        // 通常横範囲にあるとき真ん中に通常表示
        styles.left = targetPos.x + targetPos.width / 2 + 'px';
        styles.transform = 'translateX(-50%) scale(' + scale + ')';
        origin = 'center ';
      }
      if (viewportRect.top >= targetPos.y) {
        // 通常縦範囲より上にあるとき下側に表示
        styles.top = targetPos.y + targetPos.height + 'px';
        origin = origin + 'top';
      } else {
        // 通常縦範囲やより下にあるとき上側に通常表示
        styles.top = targetPos.y - scaledMenuSize.height + 'px';
        origin = origin + 'top';
      }
      return { ...styles, 'transform-origin': origin };
    } else {
      // targetがiconの場合
      if (viewportRect.right < targetPos.x + targetPos.width + margin + scaledMenuSize.width) {
        // 通常横範囲より右にあるとき左側に表示
        styles.left = targetPos.x - margin - scaledMenuSize.width + 'px';
        origin = 'left ';
      } else {
        // 通常横範囲やより左にあるとき右側に通常表示
        styles.left = targetPos.x + targetPos.width + margin + 'px';
        origin = 'left ';
      }
      if (viewportRect.bottom < targetPos.y + scaledMenuSize.height) {
        // 通常縦範囲より下にあるとき押し上げて表示
        styles.bottom = this.room.roomSize.height - viewportRect.bottom + 'px';
        origin = origin + 'bottom';
      } else {
        // 通常縦範囲やより上にあるとき通常表示
        styles.top = targetPos.y + 'px';
        origin = origin + 'top';
      }
      return { ...styles, 'transform-origin': origin };
    }
  }
  private get viewportRect() {
    const { x, y } = this.viewportPos;
    const scale = this.roomScale;
    const iscroll: any = zawaroom.iscroll;
    const wrapperWidth: number = iscroll.wrapperWidth / scale;
    const wrapperHeight: number = iscroll.wrapperHeight / scale;

    const left = Math.abs(Math.round(x / scale));
    const top = Math.abs(Math.round(y / scale));
    return {
      left,
      top,
      right: left + wrapperWidth,
      bottom: top + wrapperHeight,
      width: wrapperWidth,
      height: wrapperHeight,
    };
  }

  get user(): User {
    return this.$store.state.user;
  }

  /** アイコンや文字が小さくなってみにくいので、scale によらず同じ大きさにするために roomscaleの逆数を設定することで解消する為のscale. 小さくなりすぎるのも困るので最低は1倍とした。 */
  get scale(): number {
    return Math.max(1 / this.roomScale, 0.01);
  }
  userPosition: CoordinatesPosition = { x: 200, y: 200 };
  private moveStartPos: CoordinatesPosition = { x: 200, y: 200 };
  private moveStartMousePos: CoordinatesPosition = { x: 200, y: 200 };
  private movingTimer: any = 0;
  private prevEvent: PointerEvent | TouchEvent | null = null;
  get showSubroomArea(): boolean {
    // return this.$store.state.showSubroomArea && this.$store.state.isMoving;
    return this.$store.state.isMoving;
  }
  userStateData: UserRoomStateData[] = [];
  get participants(): UserRoomStateData[] {
    return this.userStateData.filter((p) => p.userState && p.userState.userId !== this.user.id);
  }
  get userParticipantData(): UserRoomStateData | undefined {
    if (this.user) {
      return this.userStateData.find((p) => p.userState.userId === this.user.id);
    }
    return undefined;
  }
  get sharedCount(): number {
    return this.connectionManager ? this.connectionManager.localDesktopShareCount : 0;
  }
  isListCollapsed: boolean = false;
  isToolCollapsed: boolean = true;
  roomContainer: HTMLElementWithPosition = {} as HTMLElementWithPosition;
  volumeMode: VolumeModes = 'DistanceSensitive';

  private prevSubRoomId = '';

  private currentSubRoom: SubRoom | null = null;
  get currentSubRoomId(): string {
    return this.currentSubRoom?.subid ?? this.room.id;
  }
  selectedStateOnListForMenu: {
    user: User;
    isExitUser: boolean;
    allowed: boolean;
  } | null = null;
  selectedUserPositionOnList: CoordinatesPosition = { x: 0, y: 0 };
  selectedSubroom: SubRoom | null = null;
  selectedSubroomPosition: CoordinatesPosition = { x: 0, y: 0 };
  localVideoEnabled: boolean = false;
  localAudioEnabled: boolean = false;

  wholePagePopupMessage = '';
  isScrolling = false;
  isGeneralSettingsPopupVisible = false;
  objects: RoomObject[] = [];
  get loadedImages(): RoomObject[] {
    return this.objects.filter((o) => o.objectType == 'image' || o.objectType == 'board');
  }
  shareScreens: DesktopRoomObject[] = [];
  activeShareScreenUserIds: Set<string> = new Set(); //現在画面共有中のユーザーID(ルーム全体を対象)
  messageEditor: RoomObject = {
    id: '',
    roomType: 'room',
    roomId: '',
    objectType: 'board',
    position: { x: 0, y: 0 },
    width: 0,
    height: 0,
    size: 0,
    imageBase64: '',
    isLocked: false,
    props: {},
    createdUserId: '',
    createdUserName: '',
    updatedUserId: '',
  };
  messagePopupMessage = '';
  messagePopupTitle = '';

  isUploadImagePopupVisible = false;
  isMessagePopupVisible = false;
  isLoadingPopupVisible = true;
  isImagePreviewPopupVisible = false;
  isBoardSettingPopupVisible = false;
  selectedScheduleTarget: UserRoomStateData | null = null;
  get scheduleStyle(): any {
    if (!this.selectedScheduleTarget) {
      return {};
    }
    const contextMenuSize = { width: 260, height: 426 };
    const targetBounding: BoundingPosition = {
      ...this.selectedScheduleTarget.userState.position,
      width: MAX_AVATAR_WIDTH_AND_HEIGHT,
      height: MAX_AVATAR_WIDTH_AND_HEIGHT,
    };
    return this.calcContextMenuPosition(contextMenuSize, targetBounding);
  }
  currentBoardRoomObject: RoomObject | null = null;
  private enterRoomSound = new Audio(enteringSoundFile);
  private bellRingSound = new Audio(bellRingSoundFile);
  private knockSound = new Audio(knockSoundFile);
  private openDoor = new Audio(openDoorSoundFile);
  private bgmSound = new Audio();
  private messageSound = new Audio(messageSoundFile);
  private crossSound = new Audio(crossSoundFile);

  connectionManager: RoomConnectionManager | null = null;
  roomScale: number = 1;
  viewportPos = { x: 0, y: 0 };
  minimapSize = { height: 100, width: 150 };

  private ssMoveTimer: any = {};
  private imgMoveTimer: any = {};
  private leaveJoinTimer: any = 0;
  private positionTimer: any = 0;
  private positionPrevTime: any = 0;
  private scheduleHideTimer: any = 0;
  enteredRoomObject: RoomObject | DesktopRoomObject | null = null;
  messageHistories: MessageHistory[] = [];

  initialized = false;

  get uploadedImageBase64(): string {
    return this.$store.state.uploadedImageBase64;
  }

  get connecting(): boolean {
    return this.connectionManager?.connecting ?? false;
  }
  @Watch('uploadedImageBase64')
  onUploadedImageBase64Changed(uploadedImageBase64: ImageWithDimensions | null) {
    if (uploadedImageBase64) {
      this.isImagePreviewPopupVisible = true;
    }
  }
  @Watch('isShowEditor')
  updateMessagePosition(newVal: boolean, oldVal: boolean) {
    if (newVal) {
      this.resetMessageEditPositionByMenu();
    } else {
      this.localIsEditingUserMessage = false;
    }
  }
  onLocalEditingUserMessage() {
    this.localIsEditingUserMessage = false;
  }
  onMessageSended() {
    if (this.localIsEditingUserMessage) {
      this.resetMessageEditPositionByMenu();
    }
    this.localIsEditingUserMessage = false;
  }
  created() {
    this.bgmSound.loop = true;
    this.askNotificationPermission();
    this.positionDebouncer = new Debouncer(40);
    this.objectSizeDebouncer = new Debouncer(40);
    this.videoSizeDebouncer = new Debouncer(40);
  }
  /**
   * リサイズ時のイベントハンドラ。
   * イベントハンドラ登録するので、コンテキストを持つアロー関数で実装
   */
  private onResize() {
    if (zawaroom.iscroll && zawaroom.iscroll.destroy) {
      zawaroom.iscroll.destroy();
    }
    this.setupIScroll();
    this.resetMessageEditPositionByMenuIfNeed();
  }
  zoomin() {
    if (zawaroom.iscroll) {
      zawaroom.iscroll.zoom(this.roomScale + 0.1, undefined, undefined, 100);
    }
  }
  zoomout() {
    if (zawaroom.iscroll) {
      zawaroom.iscroll.zoom(this.roomScale - 0.1, undefined, undefined, 100);
    }
  }
  private askNotificationPermission(): void {
    if (!('Notification' in window)) {
      console.log('This browser does not support notifications.');
    } else {
      if (Notification.permission !== 'denied' && Notification.permission !== 'granted') {
        Notification.requestPermission();
      }
    }
  }

  private hasRoomRights(): boolean {
    const user = this.user;
    const room = this.room;
    if (isAdmin(user)) {
      return true;
    }
    if (this.room.isPublicRoom) {
      return true;
    }

    // if (!room.allowDomains?.length && !room.allowUserEmails?.length) {
    //   return true;
    // }
    const email = user.email?.toLocaleLowerCase();
    if (!email) {
      return false;
    }
    if (
      !!room.allowDomains?.find((a) => email!.endsWith(a)) ||
      !!room.allowUserEmails?.find((e) => email === e) ||
      !!room.adminEmails?.find((e) => email === e)
    ) {
      return true;
    }
    return false;
  }

  mounted(): void {
    if (!this.hasRoomRights()) {
      this.$toast.error('入室権限がありません。');
      this.leaveRoom();
      return;
    }

    this.setSoundsVolume();
    this.showLoading();
    if (this.urlPosition) {
      this.userPosition = this.urlPosition;
    } else {
      this.userPosition = this.room.entrancePosition || this.userPosition;
    }
    this.setRoomContainer();

    // minimap のサイズ調整。縦横の大きいほうに比率を併せる
    if (this.room.roomSize.height > this.room.roomSize.width) {
      this.minimapSize.height = 100;
      this.minimapSize.width = Math.round(
        (this.room.roomSize.width / this.room.roomSize.height) * this.minimapSize.height,
      );
    } else {
      this.minimapSize.width = 150;
      this.minimapSize.height = Math.round(
        (this.room.roomSize.height / this.room.roomSize.width) * this.minimapSize.width,
      );
    }
    zawaroom.jitsi = new RoomConnectionManager(
      this.dataService,
      this.room,
      this.user,
      this.userStateData,
      this.shareScreens,
    );
    this.connectionManager = zawaroom.jitsi;
    let setting = this.$store.state;
    this.connectionManager.setDevicesNames(
      setting.audioInputDeviceId,
      setting.audioOutputDeviceId,
      setting.videoDeviceId,
    );
    this.connectionManager.enableNoiseSuppressor = this.$store.state.userProperties?.enableNoiseSuppressor ?? true;
    this.connectionManager.onDeviceUpdated(() => {
      this.$toast.info('デバイスが変更されました。');
    });
    this.joinOnDataServer();

    window.addEventListener('resize', this.onResize);
    window.addEventListener('blur', this.onWindowBlur);
    window.addEventListener('focus', this.onWindowFocus);
    document.addEventListener('paste', this.onPaste);
    window.addEventListener('keydown', this.handleKeyDown);
    window.addEventListener('pointerdown', this.closeStatusSelector);
    this.list = statusList.filter((v) => v.selectable);
  }

  async beforeDestroy(): Promise<any> {
    this.dataService.emitLeaveRoom();
    window.removeEventListener('resize', this.onResize);
    window.removeEventListener('blur', this.onWindowBlur);
    window.removeEventListener('focus', this.onWindowFocus);
    document.removeEventListener('paste', this.onPaste);
    window.removeEventListener('keydown', this.handleKeyDown);
    window.removeEventListener('pointerdown', this.closeStatusSelector);
    this.bgmSound.pause();
    zawaroom.iscroll?.destroy();
    this.iScrollTouchScreenAddon.unregisterIScrollInstance();
    return this.connectionManager?.destroy() ?? Promise.resolve();
  }

  private setupIScroll() {
    const viewportEl = this.$refs.draggableViewport as HTMLDivElement;
    const minimapEl = this.$refs.minimap as HTMLDivElement;
    const pRect = (viewportEl.parentElement as HTMLElement).getBoundingClientRect();
    const wRatio = pRect.width / this.room.roomSize.width;
    const hRatio = pRect.height / this.room.roomSize.height;
    // const zoomMin = wRatio > hRatio ? hRatio : wRatio;
    let zoomMin: number;
    switch (this.room.minScaleMode) {
      case 'custom':
        zoomMin = Math.max(0.3, Math.min((this.room.minScale ?? 40) / 100, 1));
        break;
      case 'fitWidth':
        zoomMin = Math.max(0.3, wRatio);
        break;
      case 'fitHeight':
      default:
        zoomMin = Math.max(0.3, hRatio);
    }
    const isOption: any = {
      zoom: true,
      zoomMin,
      zoomMax: this.room.maxScale ?? 1.5,
      scrollX: true,
      scrollY: true,
      mouseWheel: true,
      tap: true,
      wheelAction: 'zoom',
      freeScroll: true,
      indicators: {
        el: minimapEl,
        interactive: true,
      },
      preventDefault: false,
      deceleration: 0.0012,
    };
    zawaroom.iscroll = new IScroll(viewportEl, isOption);
    this.iScrollTouchScreenAddon.registerIScrollInstance(zawaroom.iscroll, viewportEl, this.room.roomSize);
    let initialScale: number;
    switch (this.room.initialScaleMode) {
      case 'custom':
        initialScale = (this.room.initialScale ?? zoomMin * 100) / 100;
        break;
      case 'fitWidth':
        initialScale = wRatio;
        break;
      case 'fitHeight':
      default:
        initialScale = hRatio;
        break;
    }
    this.roomScale = Math.min(Math.max(initialScale, zoomMin), isOption.zoomMax);
    this.$store.commit('SetRoomScale', this.roomScale);

    zawaroom.iscroll.zoom(initialScale, 1000, 0, 0);
    this.viewportPos = { x: zawaroom.iscroll.x, y: zawaroom.iscroll.y };
    zawaroom.iscroll.on('zoomEnd', (ev) => {
      this.roomScale = zawaroom.iscroll.scale;
      this.viewportPos = { x: zawaroom.iscroll.x, y: zawaroom.iscroll.y };
      this.$store.commit('SetRoomScale', this.roomScale);
    });
    zawaroom.iscroll.on('refresh', (ev) => {
      this.roomScale = zawaroom.iscroll.scale;
      this.viewportPos = { x: zawaroom.iscroll.x, y: zawaroom.iscroll.y };
      this.$store.commit('SetRoomScale', this.roomScale);
    });
    zawaroom.iscroll.on('scrollStart', (ev) => {
      this.isScrolling = true;
    });
    zawaroom.iscroll.on('scrollEnd', (ev) => {
      this.viewportPos = { x: zawaroom.iscroll.x, y: zawaroom.iscroll.y };
      this.isScrolling = false;
      this.initialized = true;
      this.hideWholePagePopup(false);
    });
  }
  onWindowBlur(ev: Event) {
    this.dataService.emitWindowBlur();
    this.$store.commit('setIsFocus', false);
  }
  onWindowFocus(ev: Event) {
    this.dataService.emitWindowFocus();
    this.$store.commit('setIsFocus', true);
  }
  onApplyNewSettings(gs: GeneralSettingsSnapshot) {
    this.isGeneralSettingsPopupVisible = false;
    this.$store.commit('SetSettings', gs);
    if (this.connectionManager) {
      const setting: SettingsSnapshot = gs.settings;
      this.connectionManager.setDevicesNames(
        setting.selectedAudioId,
        setting.selectedOutputId,
        setting.selectedVideoId,
      );
      if (typeof gs.properties.enableNoiseSuppressor !== 'undefined') {
        this.connectionManager.enableNoiseSuppressor = gs.properties.enableNoiseSuppressor;
      }
    }
  }

  onDisplayUserMenuOnList(ev: { rect: any; userOnMyList: { user: User; isExitUser: boolean; allowed: boolean } }) {
    const participant = this.userStateData.find((p) => {
      return p.userState.userId === ev.userOnMyList.user.id;
    });
    if (ev.userOnMyList.user.id !== this.user.id) {
      this.selectedUserPositionOnList = ev.rect;
      this.selectedStateOnListForMenu = ev.userOnMyList;
      if (participant) {
        this.selectedStateForMenu = participant;
      } else {
        this.selectedStateForMenu = null;
      }
    } else {
      this.selectedStateOnListForMenu = null;
      this.selectedStateForMenu = null;
      if (this.userParticipantData?.userState) {
        this.displayCenterOfScreen(this.userParticipantData?.userState);
      }
    }
  }

  onSubroomSelectionChanged(ev: { rect: any; subroom: SubRoom }) {
    if (ev) {
      this.selectedSubroom = ev.subroom;
      this.selectedSubroomPosition = ev.rect;
    } else {
      this.selectedSubroom = null;
    }
  }
  onClickDisplayMiddle() {
    this.displayCenterOfScreen(this.selectedStateForMenu?.userState);
  }
  displayCenterOfScreenMyself() {
    this.displayCenterOfScreen(this.userParticipantData?.userState);
  }
  displayCenterOfScreen(state: UserRoomState | undefined, skipResetZoom: boolean = false): void {
    if (!state) {
      return;
    }
    if (this.room && state.position) {
      this.scrollToCenter(state.position, skipResetZoom);
    }
    this.selectedStateOnListForMenu = null;
    this.selectedStateForMenu = null;
  }
  /**
   * 指定した場所を中心として画面をスクロールする
   *
   * @param position 中心
   * @param skipResetZoom scale を 1 にするかどうか
   */
  scrollToCenter(position: CoordinatesPosition, skipResetZoom: boolean = false) {
    if (skipResetZoom || zawaroom.iscroll.scale == 1) {
    } else {
      zawaroom.iscroll.zoom(1, 0, 0, 300);
    }

    let vp = this.$refs.roomContainerMain as HTMLDivElement;
    const scale = zawaroom.iscroll.scale ?? 1;
    let viewportWidth = Math.min(vp.clientWidth / scale, this.room.roomSize.width);
    let viewportHeight = Math.min(vp.clientHeight / scale, this.room.roomSize.height);
    let duration = skipResetZoom ? 50 : 300;
    const iconwidth = MAX_AVATAR_WIDTH_AND_HEIGHT;
    zawaroom.iscroll.scrollTo(
      (viewportWidth / 2 - position.x - iconwidth / 2) * scale,
      (viewportHeight / 2 - position.y - iconwidth / 2) * scale,
      duration,
    );
  }
  onCloseSetting() {
    this.isGeneralSettingsPopupVisible = false;
  }
  private setSoundsVolume(): void {
    this.enterRoomSound.volume = this.room.enteringSoundVolume ?? 0.3;
    this.bellRingSound.volume = 0.3;
    this.knockSound.volume = 0.5;
    this.openDoor.volume = this.room.doorSoundVolume ?? 0.5;
    this.bgmSound.volume = 0;
    this.bgmSound.autoplay = true;
    this.messageSound.volume = 0.3;
    this.crossSound.volume = 0.05;
  }

  private setRoomContainer(skipResize: boolean = false): void {
    const htmlElement: HTMLDivElement = this.$refs.roomContainer as HTMLDivElement;
    const rect = htmlElement.getBoundingClientRect();

    this.roomContainer = {
      htmlElementRef: htmlElement,
      position: { x: rect.left, y: rect.top },
      width: this.room?.roomSize.width ?? 100,
      heigh: this.room?.roomSize.height ?? 100,
    };
    if (rect.y > 100) {
      setTimeout(() => {
        this.setRoomContainer(skipResize);
      }, 200);
      return;
    }
    if (!skipResize) {
      this.onResize();
      this.scrollToCenter(this.userPosition, true);
      this.resetMessageEditPositionByMenu();
    }
  }
  onClickRemoteUser(ev: Event, stateData: UserRoomStateData) {
    ev.stopPropagation();
    this.selectedStateForMenu = stateData;
    this.selectedStateOnListForMenu = null;
  }
  onRequestShowSchedule(userData?: UserRoomStateData | null) {
    clearTimeout(this.scheduleHideTimer);
    if (userData) {
      this.selectedScheduleTarget = userData ? userData : null;
    } else {
      const current = this.selectedScheduleTarget;
      this.scheduleHideTimer = setTimeout(() => {
        if (this.selectedScheduleTarget === current) {
          this.selectedScheduleTarget = null;
        }
      }, 300);
    }
  }
  closeMenu() {
    this.selectedStateForMenu = null;
    this.selectedStateOnListForMenu = null;
    this.selectedSubroom = null;
  }
  onPointerDownHandler(e: PointerEvent) {
    const el = e.currentTarget as HTMLElement;
    e.stopPropagation();
    el.addEventListener('pointermove', this.onMouseMoveHandler);
    el.setPointerCapture(e.pointerId);
    this.moveStartPos = {
      x: this.userPosition.x * this.roomScale,
      y: this.userPosition.y * this.roomScale,
    };
    const pointerPosition: CoordinatesPosition = getEventMouseOrTouchXY(e);
    const newXWithScale = pointerPosition.x - this.roomContainer.position.x - zawaroom.iscroll.x;
    const newYWithScale = pointerPosition.y - this.roomContainer.position.y - zawaroom.iscroll.y;
    this.moveStartMousePos = {
      x: newXWithScale,
      y: newYWithScale,
    };
    this.prevEvent = null;
    this.movingTimer = setInterval(() => {
      if (this.prevEvent) {
        this.onMouseMoveHandler(this.prevEvent);
      }
    }, 100);
  }
  onMouseMoveHandler(e: PointerEvent | TouchEvent) {
    if (!e) {
      return;
    }
    this.prevEvent = e;
    e.preventDefault();
    e.stopPropagation();
    const pointerPosition: CoordinatesPosition = getEventMouseOrTouchXY(e);
    const newXWithScale = pointerPosition.x - this.roomContainer.position.x - zawaroom.iscroll.x;
    const newYWithScale = pointerPosition.y - this.roomContainer.position.y - zawaroom.iscroll.y;
    const newPosition: CoordinatesPosition = {
      x: this.moveStartPos.x + newXWithScale - this.moveStartMousePos.x,
      y: this.moveStartPos.y + newYWithScale - this.moveStartMousePos.y,
    };
    const videoPositionWithoutScale: CoordinatesPosition = getCoordinatesPositionWithoutScale(
      newPosition,
      this.roomScale,
      undefined,
      {
        x: 0,
        y: 0,
        width: this.room.roomSize.width - MAX_AVATAR_WIDTH_AND_HEIGHT,
        height: this.room.roomSize.height - MAX_AVATAR_WIDTH_AND_HEIGHT,
      }, // アイコンサイズ分小さい
    );
    if (
      typeof videoPositionWithoutScale.x !== 'number' ||
      typeof videoPositionWithoutScale.y !== 'number' ||
      isNaN(videoPositionWithoutScale.x) ||
      isNaN(videoPositionWithoutScale.y)
    ) {
      console.log('error', videoPositionWithoutScale);
      return;
    }
    const cr = getCurrentRoom(videoPositionWithoutScale, this.room.subRooms);
    if (
      this.room.guestPermission === 'approve' &&
      this.user.authType === 'guest' &&
      this.userParticipantData!.userState.allowed === false &&
      (!cr || cr.subid !== this.currentSubRoomId)
    ) {
      console.log("error: guest user cann't move outside ", videoPositionWithoutScale);
      return;
    }

    //#region 端っこホバーでスクロール機能の実装
    let posx = pointerPosition.x - this.roomContainer.position.x;
    let posy = pointerPosition.y;
    let iscroll: any = zawaroom.iscroll;
    const { wrapperWidth, wrapperHeight } = iscroll;
    const borderSize = MAX_AVATAR_WIDTH_AND_HEIGHT * this.roomScale;
    const moveDistance = 30 * this.roomScale;
    if (posx < borderSize) {
      iscroll.scrollBy(moveDistance, 0, 100);
    } else if (posx > wrapperWidth - borderSize) {
      iscroll.scrollBy(-moveDistance, 0, 100);
    }
    if (posy < borderSize) {
      iscroll.scrollBy(0, moveDistance, 100);
    } else if (posy > wrapperHeight - borderSize) {
      iscroll.scrollBy(0, -moveDistance, 100);
    }
    //#endregion

    let isMoved = this.onLocalVideoPositionChange(videoPositionWithoutScale, false, false);
    if (this.$store.state.isMoving === false) {
      this.$store.commit('SetIsMoving', isMoved);
    }
  }
  onPointerUpHandler(e: PointerEvent) {
    const el = e.currentTarget as HTMLElement;
    el.removeEventListener('pointermove', this.onMouseMoveHandler);
    el.releasePointerCapture(e.pointerId);
    this.$store.commit('SetIsMoving', false);
    this.prevEvent = null;
    clearInterval(this.movingTimer);
    this.updateSubroomMembers();
  }
  onClickRegisterMyList() {
    if (this.selectedStateForMenu) {
      this.dataService.emitRegisterMyList(this.selectedStateForMenu.userState.userId).then((listMember) => {
        this.user.myList.push(listMember);
      });
      this.selectedStateOnListForMenu = null;
      this.selectedStateForMenu = null;
    }
  }
  onClickRemoveMyList(args: { user: User; isExitUser: boolean; allowed: boolean } | UserRoomStateData | null) {
    if (
      !args ||
      (!(args as UserRoomStateData)?.userState &&
        !(args as { user: User; isExitUser: boolean; allowed: boolean })?.user)
    ) {
      return;
    }
    const userId = (args as UserRoomStateData)?.userState
      ? (args as UserRoomStateData).userState.userId
      : (args as { user: User; isExitUser: boolean; allowed: boolean }).user.id;
    if (this.selectedStateForMenu || this.selectedStateOnListForMenu) {
      this.dataService.emitRemoveMyList(userId).then(() => {
        const index = this.user.myList.findIndex((li) => li.id == userId);
        this.user.myList.splice(index, 1);
      });
      this.selectedStateForMenu = null;
      this.selectedStateOnListForMenu = null;
    }
  }

  onRemoteVideoMute(participant: UserRoomStateData) {
    participant.mutedLocally = !participant.mutedLocally;
    participant.applyVolume();
  }
  onOpenTeamsAndNotifyOpen() {
    if (this.currentSubRoomId === this.room.id) {
      return;
    }
    let emails = this.currentSubRoom?.userStates
      .filter((u) => u.userState.user.email)
      .map((u) => u.userState.user.email);
    if (emails) {
      let url = `https://teams.microsoft.com/l/call/0/0?users=${emails.join(',')}`;
      window.open(url, '_blank');
      this.dataService.emitOpenTeams(this.currentSubRoomId, this.user.id);
    }
  }
  onOpenTeamsChat() {
    let invitedUserEmail =
      this.selectedStateForMenu?.userState.user.email || this.selectedStateOnListForMenu?.user.email;
    if (invitedUserEmail) {
      let url = `https://teams.microsoft.com/l/chat/0/0?users=${invitedUserEmail}`;
      window.open(url, '_blank');
    }
  }

  private joinOnDataServer(): void {
    this.dataService.onJoinAnotherBrowser(() => {
      this.$toast.warning(
        '別のブラウザでログインされました。同時に入室することができないため、一覧画面に遷移しました。',
        {
          timeout: 30 * 1000,
          closeOnClick: true,
        },
      );
      this.leaveRoom();
    });
    //#region dataservice への handerの登録
    this.dataService.onLocalUserJoinedSubRoom((objects: RoomObject[]) => {
      this.onSubRoomJoined(objects);
    });
    this.dataService.onJoinedSubroom((args) => {
      if (
        args.userId !== this.user.id &&
        args.subId === this.currentSubRoomId &&
        args.subId !== this.room.id &&
        this.openDoor.paused
      ) {
        this.openDoor.play();
      }
    });
    this.dataService.onReconnected(() => {
      console.log('reconnected');
      this.dataService
        .emitJoinRoom(
          this.space.id,
          this.room.id,
          !this.localAudioEnabled,
          !this.localVideoEnabled,
          true,
          this.userPosition,
        )
        .then(() => {
          this.dataService.emitPosition(this.userPosition);
          if (this.userParticipantData?.userState.userMessage) {
            this.dataService.emitMessage(this.userParticipantData?.userState.userMessage, true);
          }
          this.updateCurrentSubRoom(this.currentSubRoom, true);
        });
    });
    this.dataService.onUsersState((userJoinedNotification: boolean, room: Room, joinUserId?: string) =>
      this.onUsersStateReceived(userJoinedNotification, room, joinUserId),
    );
    this.dataService.onRemoveRemoteUser((userIdInConference: string) => this.removeRemoteUser(userIdInConference));
    this.dataService.onAudioMuted((userMetadata: UserRoomState) =>
      this.onAudioMutedReceived(userMetadata.userId, userMetadata.audioMuted),
    );
    this.dataService.onVideoMuted((userMetadata: UserRoomState) =>
      this.onVideoMutedReceived(userMetadata.userId, userMetadata.videoMuted),
    );
    this.dataService.onSpeakerMuted((userMetadata: UserRoomState) =>
      this.onSpeakerMutedReceived(userMetadata.userId, userMetadata.speakerMuted),
    );
    this.dataService.onVoiceArea((userMetadata: UserRoomState) =>
      this.onVoiceAreaReceived(userMetadata.userId, userMetadata.voiceArea),
    );
    this.dataService.onStatus((userMetadata: UserRoomState) =>
      this.onStatusReceived(userMetadata.userId, userMetadata.status),
    );
    this.dataService.onPosition((userMetadata: UserRoomState) =>
      this.onPositionMessageReceived(userMetadata.userId, userMetadata.position),
    );
    // this.dataService.onHand((userMetadata: UserOnServer) => this.onRaisedHandMessageReceived(userMetadata.userId, userMetadata.handRaised));
    this.dataService.onMessage((userMetadata: UserRoomState) =>
      this.onUserMessageReceived(userMetadata.userId, userMetadata.userMessage),
    );
    this.dataService.onWindowFocusChanged((data: { userId: string; isFocus: boolean }) =>
      this.onWindowFocusChanged(data.userId, data.isFocus),
    );
    this.dataService.onUpdateUserProps((user) => this.onUpdateUserProps(user));
    this.dataService.onRenderImage((payload: RoomObject) => this.onImageReceived(payload));
    this.dataService.onRegisterBoard((payload: RoomObject) => this.onRegisterBoard(payload));
    this.dataService.onUpdateBoard((payload: RoomObject) => this.onRoomObjectUpdated(payload));
    this.dataService.onRoomObjectUpdated((payload: RoomObject) => this.onRoomObjectUpdated(payload));
    this.dataService.onResponseGetSchedule((payload: GetScheduleResponse | undefined) =>
      this.onResponseGetSchedule(payload),
    );
    this.dataService.onChangeImagePosition((payload: RoomObject) => this.onImagePositionChangedReceived(payload));
    this.dataService.onUpdateObjectSize((payload: RoomObject) => this.onObjectSizeChangedReceived(payload));

    this.dataService.onChangeShareScreenVideoPosition((arg: RoomObject) =>
      this.onShareScreenVideoPositionChangedReceived(arg),
    );
    this.dataService.onUpdateShareScreenVideoSize((arg: RoomObject) => this.onShareScreenVideoSizeChangedReceived(arg));
    this.dataService.onImageDeleted((image: RoomObject) => this.onImagesDeletedReceived(image));
    this.dataService.onBellRang(() => this.bellRingSound.play());
    this.dataService.onKnockByUser((args: { fromUserId: string; toUserId: string }) => this.onKnockByUser(args));
    this.dataService.onResponsedByKnockUser((args: { message: string }) => this.onResponsedByKnockUser(args));
    this.dataService.onJoinRequestSent((fromUserId: string) => this.onJoinRequestSent(fromUserId));
    this.dataService.onAllowedJoinRoom((args: { userId: string }) => this.onAllowedJoinRoom(args));

    this.dataService.onAudioLevelChanged((args: { userId: string; audioLevel: number }) =>
      this.onAudioLevelChanged(args),
    );
    this.dataService.onUpdateMessageHistories((mes) => (this.messageHistories = mes));
    this.dataService.onRoomLogsUpdated((logs) => this.logManager.addLogs(logs));
    this.dataService.onActiveShareScreenUsersChange((activeShareScreenUserIds: string[]) => {
      this.activeShareScreenUserIds.clear();
      activeShareScreenUserIds.forEach((id) => this.activeShareScreenUserIds.add(id));
    });
    //#endregion

    this.dataService
      .emitJoinRoom(this.space.id, this.room.id, !this.localAudioEnabled, !this.localVideoEnabled)
      .then(() => {
        this.onRoomJoined();
      });
  }

  onPaste(ev: ClipboardEvent) {
    console.log('paste', ev, ev.clipboardData);
    const items = ev.clipboardData?.items;
    if (!items) {
      return;
    }
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      if (item.type.indexOf('image') > -1) {
        // 画像のみサーバへ送信する
        const file = item.getAsFile();
        if (!file) {
          return;
        }
        const url = URL.createObjectURL(file);
        const img = document.createElement('img');
        img.onload = () => {
          URL.revokeObjectURL(url);
          const imageInfo: ImageWithDimensions = {
            base64: '',
            width: img.width,
            height: img.height,
            file,
          };
          this.$store.commit('SetUploadedImageBase64', imageInfo);
        };
        img.src = url;
      }
    }
  }
  private onAudioLevelChanged(args: { userId: string; audioLevel: number }) {
    let state = this.userStateData.find((p) => p.userState.userId === args.userId);
    state?.onAudioLevelChanged(args.audioLevel);
  }
  private onRoomJoined(): void {
    if (this.$store.state.isVideoEnabledOnInit) {
      this.toggleLocalVideo();
    }
    if (this.$store.state.isAudioEnabledOnInit) {
      this.toggleLocalAudio();
    }
    this.dataService.emitGetRoomLog().then((logs) => this.logManager.addLogs(logs));
  }
  onSubRoomJoined(objects: RoomObject[]) {
    this.objects = objects.filter((o) => o.objectType !== 'share screen');
    this.objects.forEach((o) => {
      if (o.position.x < 0) {
        o.position.x = 0;
      }
      if (o.position.y < 0) {
        o.position.y = 0;
      }
      if (o.position.x > this.room.roomSize.width) {
        o.position.x = this.room.roomSize.width - 100;
      }
      if (o.position.y > this.room.roomSize.height) {
        o.position.y = this.room.roomSize.height - 100;
      }
    });
  }
  private onUsersStateReceived(userJoinedNotification: boolean, room: Room, joinUserId?: string): void {
    if (room.roomStates) {
      room.roomStates.forEach((r) => {
        if (!r.user.avatarBase64) {
          r.user.avatarBase64 = '';
        }
        let d = this.userStateData.find((p) => p.userState.userId === r.userId);

        if (!d) {
          if (!joinUserId) {
            console.log('おかしい？join してない更新情報を取得');
          }
          d = new UserRoomStateData(r);
          this.userStateData.push(d);
          this.onPositionMessageReceived(d.userState.userId, d.userState.position);
        } else {
          d.userState = r;
          this.onPositionMessageReceived(d.userState.userId, d.userState.position);
        }
      });
      this.room.roomStates = room.roomStates;
      if (joinUserId === this.user.id && this.urlPosition) {
        this.onLocalVideoPositionChange(this.urlPosition, true);
      } else if (joinUserId === this.user.id) {
        this.onLocalVideoPositionChange(this.userParticipantData!.userState.position, true);
      }
      if (userJoinedNotification) {
        const properties: UserProperties = this.$store.state.userProperties;
        const notificationMode: NotificationModes = properties.selectedNotificationMode;
        const joinUserState = this.userStateData.find((usd) => usd.userState.userId === joinUserId);
        const message = `${joinUserState?.userState.user.name}さんが入室しました。`;
        const doNotify = () => {
          if (joinUserId !== this.user.id) {
            this.notification(message);
          }
          this.enterRoomSound.play();
        };
        if (notificationMode === 'All') {
          // 全員通知
          doNotify();
        } else if (notificationMode === 'No') {
          // 通知なし
        } else if (notificationMode === 'Custom') {
          const customMode: CustomModes = properties.selectedCustomModes ?? [];
          if (customMode.includes('Mylist')) {
            const target = this.user?.myList.find((item) => item.id === joinUserId);
            if (target) {
              doNotify();
            }
          } else if (customMode.includes('Guest')) {
            if (joinUserState?.userState.user.authType === 'guest') {
              doNotify();
            } else {
              const email = joinUserState?.userState.user.email?.toLocaleLowerCase() ?? '';
              let org = this.space.organizations.find((o) => email.endsWith(o.toLocaleLowerCase()));
              if (!org) {
                doNotify();
              }
            }
          }
        }
      }
    }
    this.updateAllUsersVolume();
    this.updateAllShareScreenVisualStates();
  }
  private notification(message: string) {
    if (Notification?.permission === 'granted') {
      const notification = new Notification('zawaroom', { body: message });
      notification.addEventListener('click', () => {
        window.focus();
      });
    }
  }
  private removeRemoteUser(userId: string): void {
    const index = this.userStateData.findIndex((p) => p.userState.userId === userId);
    if (index >= 0) {
      this.userStateData.splice(index, 1);
    }
    if (this.room.roomStates) {
      let i = this.room.roomStates.findIndex((rs) => rs.userId == userId);
      if (i >= 0) {
        this.room.roomStates.splice(i, 1);
      }
    }
    if (this.selectedStateForMenu && this.selectedStateForMenu.userState.userId === userId) {
      this.selectedStateForMenu = null;
    }
    if (this.selectedStateOnListForMenu && this.selectedStateOnListForMenu.user.id === userId) {
      this.selectedStateOnListForMenu = null;
    }
    this.updateOtherSpeakerAndAudience();
    this.updateSubroomMembers();
    this.requestPipUpdateFrame();
  }

  private onImageReceived(receivedImage: RoomObject): void {
    this.hideWholePagePopup(false);
    this.objects.push(receivedImage);
  }
  private onRegisterBoard(ro: RoomObject): void {
    this.objects.push(ro);
  }
  private onRoomObjectUpdated(ro: RoomObject): void {
    const target =
      ro.objectType === 'share screen'
        ? this.shareScreens.find((o) => o.id === ro.id)
        : this.objects.find((o) => o.id === ro.id);
    if (target) {
      Object.assign(target, ro);
      this.$nextTick(() => this.requestPipUpdateFrame());
    } else {
      console.error('通知の object が見つかりません。', this.objects, ro);
    }
  }
  private onResponseGetSchedule(payload: GetScheduleResponse | undefined) {
    if (payload) {
      payload.value.forEach((sch) => {
        let u = this.userStateData.find((us) => us.userState.user.email === sch.scheduleId);
        if (u) {
          u.scheduleInfo = sch;
        }
      });
    }
  }
  onMaximizeScreenShareRequested(shareScreen: RoomObject, size: { width: number; height: number }) {
    // shareScreen.
    const iscroll: any = zawaroom.iscroll;
    const vscale = iscroll.wrapperHeight / size.height;
    const hscale = iscroll.wrapperWidth / size.width;

    const offset = 40; // メニューバーの高さ
    if (vscale > hscale) {
      if (this.roomScale !== hscale) {
        zawaroom.iscroll.zoom(hscale);
      }
      const hoffset = (iscroll.wrapperHeight - size.height * zawaroom.iscroll.scale) / 2;
      zawaroom.iscroll.scrollTo(
        shareScreen.position.x * hscale * -1,
        (shareScreen.position.y + offset) * hscale * -1 + hoffset,
        200,
      );
    } else {
      if (this.roomScale !== vscale) {
        zawaroom.iscroll.zoom(vscale);
      }
      const woffset = (iscroll.wrapperWidth - size.width * zawaroom.iscroll.scale) / 2;
      zawaroom.iscroll.scrollTo(
        shareScreen.position.x * vscale * -1 + woffset,
        (shareScreen.position.y + offset) * vscale * -1,
        200,
      );
    }
  }

  private onImagePositionChangedReceived(payload: RoomObject): void {
    if (payload.updatedUserId == this.user.id) {
      // 自分で動かした場合は何もしない
      return;
    }
    const imgRef: RoomObject | undefined = this.objects.find((img: RoomObject) => {
      return img.id === payload.id;
    });
    if (imgRef) {
      imgRef.position = payload.position;
      this.$nextTick(() => this.requestPipUpdateFrame());
    }
  }

  private onObjectSizeChangedReceived(payload: RoomObject): void {
    if (payload.updatedUserId === this.user.id) {
      // 自分で動かした場合は何もしない
      return;
    }
    const imgRef: RoomObject | undefined = this.objects.find((img: RoomObject) => {
      return img.id === payload.id;
    });
    if (imgRef) {
      imgRef.size = payload.size;
      imgRef.width = payload.width;
      imgRef.height = payload.height;
      imgRef.position.x = payload.position.x;
      imgRef.position.y = payload.position.y;

      this.$nextTick(() => this.requestPipUpdateFrame());
    }
  }
  private onShareScreenVideoPositionChangedReceived(arg: RoomObject): void {
    if (this.user.id == arg.updatedUserId) {
      // 自分で動かした場合は何もしない
      return;
    }
    const shareScreen = this.shareScreens.find((ss) => ss.id === arg.id);
    if (shareScreen) {
      shareScreen.position = arg.position;
    }
  }

  private onShareScreenVideoSizeChangedReceived(payload: RoomObject): void {
    if (this.user.id == payload.updatedUserId) {
      // 自分で動かした場合は何もしない
      return;
    }
    const shareScreen = this.shareScreens.find((ss) => ss.id === payload.id);
    if (shareScreen) {
      shareScreen.size = payload.size;
      shareScreen.width = payload.width;
      shareScreen.height = payload.height;
      shareScreen.position.x = payload.position.x;
      shareScreen.position.y = payload.position.y;
    }
  }

  private onImagesDeletedReceived(image: RoomObject): void {
    const index = this.objects.findIndex((o) => o.id === image.id);
    if (index >= 0) {
      this.objects.splice(index, 1);
      this.$nextTick(() => this.requestPipUpdateFrame());
    }
  }

  private sendPositionOfLocalVideo(): void {
    this.positionDebouncer.execute(() => {
      this.dataService.emitPosition(this.userPosition);
    }, 20);
  }

  private onAudioMutedReceived(userId: string, isMuted: boolean): void {
    const participant = this.userStateData.find((p) => p.userState.userId === userId);
    if (participant) {
      participant.userState.audioMuted = isMuted;
      this.updateOtherSpeakerAndAudience();
    }
  }
  private onVideoMutedReceived(userId: string, isMuted: boolean): void {
    const participant = this.userStateData.find((p) => p.userState.userId === userId);
    if (participant) {
      participant.userState.videoMuted = isMuted;
      this.updateOtherSpeakerAndAudience();
    }
  }
  private onSpeakerMutedReceived(userId: string, isMuted: boolean): void {
    const participant = this.userStateData.find((p) => p.userState.userId === userId);
    if (participant) {
      participant.userState.speakerMuted = isMuted;
    }
  }
  private onVoiceAreaReceived(userId: string, voiceArea?: number): void {
    const participant = this.userStateData.find((p) => p.userState.userId === userId);
    if (participant) {
      participant.userState.voiceArea = voiceArea;
      if (participant.userState.userId === this.user.id) {
        this.updateAudience();
      } else {
        this.updateVolume(participant, true);
      }
    }
  }
  private onStatusReceived(userId: string, status: string): void {
    const participant = this.userStateData.find((p) => p.userState.userId === userId);
    if (participant) {
      participant.userState.status = status;
    }
  }

  private onPositionMessageReceived(userId: string, participantPosition: CoordinatesPosition) {
    if (
      !participantPosition ||
      typeof participantPosition.x !== 'number' ||
      typeof participantPosition.y !== 'number'
    ) {
      console.warn('バグ？不正なデータが送られてきました。', participantPosition);
      return;
    }
    if (userId === this.user.id) {
      // 自分の位置の処理は終わっているはずなので何もしない
      return;
    }
    const participantData = this.userStateData.find((p) => p.userState.userId === userId);

    if (participantData) {
      participantData.userState.position = participantPosition;
      participantData.subRoomId = getCurrentRoom(participantPosition, this.room.subRooms)?.subid ?? this.room.id;
      this.updateVolume(participantData, true);
      if (
        participantData.distanceSensitiveVolume > 0 &&
        this.currentSubRoomId === this.room.id &&
        participantData.subRoomId === this.room.id &&
        this.crossSound.paused
      ) {
        const properties: UserProperties = this.$store.state.userProperties;
        const notificationMode: NotificationModes = properties.selectedProximityNotificationMode;
        if (notificationMode === 'All') {
          // 全員通知
          this.crossSound.play();
        } else if (notificationMode === 'No') {
          // 通知なし
        } else if (notificationMode === 'Custom') {
          const target = this.user?.myList.find((item) => item.id === userId);
          if (target) {
            this.crossSound.play();
          }
        }
      }
      if (participantData.distanceSensitiveVolume <= 0 && !this.crossSound.paused) {
        this.crossSound.pause();
        this.crossSound.currentTime = 0;
      }
    } else {
      console.error('対象のユーザーが見つかりません。', userId);
    }
    this.updateSubroomMembers();
    this.updateAllShareScreenVisualStates();
    this.$nextTick(() => this.requestPipUpdateFrame());
    return;
  }

  private onUserMessageReceived(userId: string, message: string): void {
    const participant = this.userStateData.find((p) => p.userState.userId === userId);
    if (!participant) {
      return;
    }
    const messageContent = (participant.userState.userMessage = message);
    const senderName = participant.userState.user.name;
    const notificationContent = `${senderName}さんがメッセージを入力しました。「${messageContent}」`;
    const properties: UserProperties = this.$store.state.userProperties;
    const notificationMode: NotificationModes = properties.selectedMessageNotificationMode;
    if (
      participant.distanceSensitiveVolume > 0 &&
      this.currentSubRoomId === this.room.id &&
      participant.subRoomId === this.room.id &&
      messageContent !== ''
    ) {
      const doNotify = () => {
        if (userId !== this.user.id) {
          this.notification(notificationContent);
        }
        this.messageSound.play();
      };
      if (notificationMode === 'All') {
        // 全員通知
        doNotify();
      } else if (notificationMode === 'No') {
        // 通知なし
      } else if (notificationMode === 'Custom') {
        const target = this.user?.myList.find((item) => item.id === userId);
        if (target) {
          doNotify();
        }
      }
    }
    this.requestPipUpdateFrame();
  }
  private onWindowFocusChanged(userId: string, isFocus: boolean): void {
    const participant = this.userStateData.find((p) => p.userState.userId === userId);
    if (participant) {
      participant.userState.isFocus = isFocus;
    }
  }

  private onUpdateUserProps(user: Partial<User>): void {
    console.log('update user props', user);
    const props = (Object.keys(user) as (keyof User)[]).filter((p) => p !== 'id');
    if (props.length) {
      const participant = this.userStateData.find((p) => {
        return p.userState.userId === user.id;
      });
      if (participant?.userState?.user) {
        const u: User = participant.userState.user;
        props.forEach((p) => this.$set(u, p, user[p]));
      }
      if (user.id === this.user.id) {
        const u: User = this.user;
        props.forEach((p) => this.$set(u, p, user[p]));
      }
    }
  }

  private onJoinRequestSent(fromUserId: string): void {
    if (fromUserId === this.user.id) {
      this.messagePopupTitle = 'ロビーで待機';
      this.messagePopupMessage = `${this.room.name}への入室には社内メンバーの承認が必要です。\n 承認されるまでお待ちください。`;
      this.isMessagePopupVisible = true;
      return;
    } else if (isGuest(this.user, this.space)) {
      return;
    }
    const stateData = this.participants.find((p) => p.userState.userId === fromUserId);
    this.messagePopupTitle = 'ゲストユーザーの入室';
    this.messagePopupMessage = `${stateData!.userState.user.name}さんが入室しました。入室を許可してください。`;
    this.isMessagePopupVisible = true;
  }

  private onAllowedJoinRoom(args: { userId: string }): void {
    if (this.user.id === args.userId) {
      this.userParticipantData!.userState.allowed = true;
      this.messagePopupTitle = '';
      this.messagePopupMessage = `入室が許可されました`;
      this.isMessagePopupVisible = true;
      return;
    }
    let participantData = this.userStateData.find((p) => p.userState.userId === args.userId);
    if (!participantData) {
      console.error('対象のユーザーが見つかりません。', args.userId);
    }
    if (this.selectedStateOnListForMenu) {
      this.selectedStateOnListForMenu.allowed = true;
    }
    participantData!.userState.allowed = true;
    this.updateSubroomMembers();
  }

  showLoading(): void {
    this.isLoadingPopupVisible = true;
  }

  hideWholePagePopup(checkIfError: boolean): void {
    let isError = false;
    if (checkIfError) {
      isError = this.isLoadingPopupVisible;
      if (isError) {
        this.showMessagePopup('ファイルアップロード', UPLOAD_IMAGE_ERROR);
      }
    }
    this.isLoadingPopupVisible = false;
  }

  private showMessagePopup(title: string, message: string): void {
    this.messagePopupMessage = message;
    this.messagePopupTitle = title;
    this.isMessagePopupVisible = true;
  }

  private updateAllUsersVolume() {
    this.userStateData.forEach((p) => {
      this.updateVolume(p);
    });
    this.updateOtherSpeakerAndAudience();
  }
  private updateAllShareScreenVisualStates() {
    const myUserRoomState = this.userStateData.find((urs) => urs.userState.userId === this.user.id);
    if (myUserRoomState) {
      this.shareScreens.forEach((ss) => {
        ss.updateVisualStates(myUserRoomState.userState, this.currentSubRoom?.volume);
      });
    }
  }

  private updateOtherSpeakerAndAudience() {
    if (this.connectionManager) {
      this.updateOtherSpeaker();
      this.updateAudience();
    }
  }
  /**
   * 対象のparticipant の現在の volume を更新します。
   * @param participant updateVolume を呼び出す参加者
   * @param updateSpeaker jitsi.hasOtherSpeaker を更新するための処理を実行するかどうか。全participant に対してupdateVolume をしている場合は、 false にしてから再度行うことを想定しています。
   */
  private updateVolume(participant: UserRoomStateData, updateSpeaker?: boolean) {
    if (participant.userState.userId === this.user.id) {
      // 自分自身の場合は何もしない
      return;
    }
    const oldModeVolume = participant.modeVolume;
    const roomVolume = this.currentSubRoom?.volume ?? -1;
    participant.updateVolume(this.userPosition, this.currentSubRoomId, roomVolume, this.volumeMode);
    if (updateSpeaker && this.connectionManager) {
      if (oldModeVolume <= 0 && participant.modeVolume > 0) {
        if (!participant.userState.audioMuted) {
          this.connectionManager.hasOtherSpeaker = true;
        }
        this.connectionManager.hasAudience = true;
      } else if (participant.modeVolume <= 0) {
        this.updateOtherSpeakerAndAudience();
      }
    }
  }
  /**
   * jitsi に 他の話者が居るかどうかを設定します。
   *
   * この関数は、pariticipant の modeVolume を見ているため、updateVolume が呼び出されていることが前提です。
   */
  private updateOtherSpeaker() {
    let hasOtherSpeaker = false;
    for (let i = 0; i < this.userStateData.length; i++) {
      const p = this.userStateData[i];
      if (p.userState.userId === this.user.id) {
        // 自分自身の場合は何もしない
        continue;
      }
      if (p.modeVolume > 0 && (p.userState?.audioMuted === false || p.userState?.videoMuted === false)) {
        hasOtherSpeaker = true;
        break;
      }
    }
    if (this.connectionManager) {
      this.connectionManager.hasOtherSpeaker = hasOtherSpeaker;
    }
  }
  /**
   * jitsi に 視聴者が居るかどうかを設定します。
   */
  private updateAudience() {
    if (!this.userParticipantData || !this.connectionManager) {
      return;
    }
    const threshold = this.userParticipantData.userState.voiceArea ?? NO_SOUND_THRESHOLD_DISTANCE;
    for (let i = 0; i < this.userStateData.length; i++) {
      const p = this.userStateData[i];
      if (this.userParticipantData === p || !p.isSameSubRoom) {
        continue;
      }
      if (p.modeVolume >= 1) {
        this.connectionManager.hasAudience = true;
        return;
      }
      const distance = this.userParticipantData.calculateDistance(p.userState.position);
      if (distance <= threshold) {
        this.connectionManager.hasAudience = true;
        return;
      }
    }
    this.connectionManager.hasAudience = false;
    return;
  }

  switchToMode(mode: VolumeModes): void {
    if (this.volumeMode === mode) {
      return;
    }
    this.volumeMode = mode;
    this.dataService.emitSpeakerMuted(mode === 'Muted');
    this.updateAllUsersVolume();
  }

  toggleLocalVideo(): void {
    this.localVideoEnabled = !this.localVideoEnabled;
    this.dataService.emitVideoMuted(!this.localVideoEnabled);
    if (this.connectionManager) {
      this.connectionManager.localVideoDisabled = !this.localVideoEnabled;
    }
    this.$store.commit('SetIsVideoEnableOnInit', this.localVideoEnabled);
  }

  toggleLocalAudio(): void {
    this.localAudioEnabled = !this.localAudioEnabled;
    this.dataService.emitAudioMuted(!this.localAudioEnabled);
    if (this.connectionManager) {
      this.connectionManager.localAudioDisabled = !this.localAudioEnabled;
    }
    if (this.localAudioEnabled && this.volumeMode === 'Muted') {
      this.$toast.info({
        component: ToastWithButtonPopup,
        props: { message: 'スピーカーが無効です', buttonCaption: '有効にする' },
        listeners: {
          buttonClick: () => {
            this.switchToMode('DistanceSensitive');
          },
        },
      });
    }
    this.$store.commit('SetIsAudioEnableOnInit', this.localAudioEnabled);
  }

  onToggleShareScreen() {
    this.connectionManager?.startShareScreen();
  }

  allowGuestUser(): void {
    this.dataService.emitAllowGuestUser(this.selectedStateForMenu!.userState.user.id);
  }

  moveCloserToRemoteVideo(): void {
    let remoteParticipant = this.selectedStateForMenu;
    if (remoteParticipant && remoteParticipant.userState.position) {
      let newPos: CoordinatesPosition = {
        x: remoteParticipant.userState.position.x,
        y: remoteParticipant.userState.position.y,
      };
      if (
        remoteParticipant.subRoomId ===
        (getCurrentRoom({ x: newPos.x - 115, y: newPos.y }, this.room.subRooms)?.subid ?? this.room.id)
      ) {
        newPos = {
          x: newPos.x - 115,
          y: newPos.y,
        };
      } else if (
        remoteParticipant.subRoomId ===
        (getCurrentRoom({ x: newPos.x + 115, y: newPos.y }, this.room.subRooms)?.subid ?? this.room.id)
      ) {
        newPos = {
          x: newPos.x + 115,
          y: newPos.y,
        };
      } else if (
        remoteParticipant.subRoomId ===
        (getCurrentRoom({ x: newPos.x, y: newPos.y + 115 }, this.room.subRooms)?.subid ?? this.room.id)
      ) {
        newPos = {
          x: newPos.x,
          y: newPos.y + 115,
        };
      } else if (
        remoteParticipant.subRoomId ===
        (getCurrentRoom({ x: newPos.x, y: newPos.y - 115 }, this.room.subRooms)?.subid ?? this.room.id)
      ) {
        newPos = {
          x: newPos.x,
          y: newPos.y - 115,
        };
      }
      this.onLocalVideoPositionChange(newPos, false, true);
      this.selectedStateForMenu = null;
      this.selectedStateOnListForMenu = null;
    }
  }
  onKnockUser(user: User) {
    if (user && user.id) {
      this.moveCloserToRemoteVideo();
      this.dataService.emitKnock(user.id);
    }
  }
  onResponsedByKnockUser(args: { message: string }) {
    this.$toast.info(args.message, {
      timeout: 30 * 1000,
      closeOnClick: true,
      onClose: () => {
        this.knockSound.pause();
      },
    });
  }
  onKnockByUser(args: { fromUserId: string; toUserId: string }) {
    console.log('knocked...', args);
    let p = this.participants.find((ps) => ps.userState.userId === args.fromUserId);
    if (p) {
      const isFocus = this.$store.state.isFocus;
      const now = new Date();
      const message =
        now.toLocaleDateString('ja-JP') +
        ' ' +
        now.toLocaleTimeString('en-US', {
          hour12: false,
          hour: '2-digit',
          minute: '2-digit',
        }) +
        ' ' +
        p.userState.user.name +
        ' さんから声をかけられています。';
      this.$toast.info(
        {
          component: ToastKnockedUser,
          props: {
            message: message,
          },
          listeners: {
            clickButtonOnToast: (m: string) =>
              this.dataService.emitResponsedByKnockUser(args.fromUserId, this.user.name + 'さんが返答しました。 ' + m),
          },
        },
        {
          timeout: isFocus ? 30 * 1000 : 0,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          onClose: () => {
            this.knockSound.pause();
          },
        },
      );
      if (Notification?.permission === 'granted') {
        new Notification('zawaroom', { body: message });
      }
      if (this.knockSound.paused) {
        this.knockSound.play();
      }
    }
  }
  private updateSubroomMembers() {
    let subroomsIndexes: { [subroom: string]: UserRoomStateData[] } = {};
    this.userStateData.forEach((v) => {
      let index = v.subRoomId ?? '';
      let list = subroomsIndexes[index] || (subroomsIndexes[index] = []);
      list.push(v);
    });
    this.room.subRooms.forEach((r, i) => {
      this.$set(r, 'userStates', subroomsIndexes[r.subid] ?? []);
    });
  }

  private onLocalVideoPositionChange(destination: CoordinatesPosition, force?: boolean, immediate?: boolean): boolean {
    if (!force && this.userPosition.x === destination.x && this.userPosition.y === destination.y) {
      return false;
    }
    this.updateCurrentSubRoom(getCurrentRoom(destination, this.room.subRooms), force, immediate);
    this.userPosition = destination;
    if (this.userParticipantData) {
      this.userParticipantData.userState.position = destination;
    }
    this.$router
      .replace({
        path: `/room/${this.space.id}/${this.room.id}`,
        query: {
          x: this.userPosition.x.toString(),
          y: this.userPosition.y.toString(),
        },
      })
      .catch((err) => {
        if (err.name !== 'NavigationDuplicated') {
          console.error(err);
        }
      });
    this.sendPositionOfLocalVideo();
    this.updateAllUsersVolume();
    this.updateAllShareScreenVisualStates();

    this.requestPipUpdateFrame();
    return true;
  }
  private updateCurrentSubRoom(subRoom?: SubRoom | null, force?: boolean, immediate?: boolean): void {
    if ((this.currentSubRoom === subRoom || (!this.currentSubRoom && !subRoom)) && !force) {
      return;
    }
    if (this.leaveJoinTimer && !force) {
      clearTimeout(this.leaveJoinTimer);
      this.leaveJoinTimer = 0;
    } else {
      this.prevSubRoomId = this.currentSubRoomId;
    }
    this.currentSubRoom = subRoom ?? null;
    if (this.connectionManager) {
      this.connectionManager.setCurrentSubRoom(subRoom ?? null);
    }
    const up = this.userParticipantData;
    if (up) {
      up.subRoomId = this.currentSubRoomId;
      up.roomVolume = this.currentSubRoom?.volume ?? -1;
    }
    if (this.currentSubRoom) {
      const subRoom = this.currentSubRoom;
      if (subRoom.bgmUrl && subRoom.bgmAudioVolume && subRoom.bgmAudioVolume > 0) {
        this.bgmSound.src = subRoom.bgmUrl;
        this.bgmSound.volume = subRoom.bgmAudioVolume || 0;
      } else {
        this.bgmSound.volume = 0;
        this.bgmSound.pause();
      }
    } else {
      this.bgmSound.volume = 0;
      this.bgmSound.pause();
    }

    if (!force && this.currentSubRoomId === this.prevSubRoomId) {
      return;
    }
    this.updateSubroomMembers();

    const dojoin = () => {
      if (this.prevSubRoomId) {
        this.dataService.emitLeaveSubRoom(this.room.id, this.prevSubRoomId, this.user.id);
      }
      this.dataService.emitJoinSubRoom(this.currentSubRoomId);
      this.leaveJoinTimer = 0;
    };
    if (force || immediate) {
      dojoin();
    } else {
      this.leaveJoinTimer = setTimeout(() => {
        dojoin();
      }, 300);
    }
  }

  onRemoveMessage(): void {
    this.dataService.emitMessage('');
  }

  onBellButtonClick(): void {
    this.dataService.emitBellRing();
  }

  hideUploadImagePopup(): void {
    this.isUploadImagePopupVisible = false;
  }

  hideMessagePopup(): void {
    this.isMessagePopupVisible = false;
  }

  hideImagePreviewPopup(): void {
    this.isImagePreviewPopupVisible = false;
  }

  onLoadedImagePositionChange(args: { newPosition: CoordinatesPosition; roomObject: RoomObject }): void {
    const { roomObject, newPosition } = args;
    roomObject.position = newPosition;
    if (this.imgMoveTimer[roomObject.id]) {
      clearTimeout(this.imgMoveTimer[roomObject.id]);
    }
    this.imgMoveTimer[roomObject.id] = setTimeout(() => {
      const ro = this.loadedImages.find((r) => r.id === roomObject.id);
      if (ro) {
        this.dataService.emitImagePositionChanged(ro.id, newPosition, this.currentSubRoomId, this.user.id);
      }
    }, 50);
  }

  onShareScreenVideoPositionChange(args: { newPosition: CoordinatesPosition; roomObject: RoomObject }): void {
    const { roomObject, newPosition } = args;
    roomObject.position = newPosition;
    if (this.ssMoveTimer[roomObject.id]) {
      clearTimeout(this.ssMoveTimer[roomObject.id]);
    }
    this.ssMoveTimer[roomObject.id] = setTimeout(() => {
      const ro = this.shareScreens.find((r) => r.id === roomObject.id);
      if (ro) {
        this.dataService.emitScreenShareVideoPositionChanged(ro.id, newPosition, this.currentSubRoomId, this.user.id);
      }
    }, 50);
    this.updateAllShareScreenVisualStates();
  }

  onChangeSize(args: { newSize: BoundingPosition; roomObject: RoomObject }): void {
    const { newSize, roomObject } = args;
    if (roomObject.objectType !== 'image' && roomObject.props.boardType !== 'image') {
      roomObject.width = newSize.width;
      roomObject.height = newSize.height;
    }
    roomObject.position.x = newSize.x;
    roomObject.position.y = newSize.y;
    roomObject.size = newSize.height;
    this.objectSizeDebouncer.execute(() => {
      this.dataService.emitNewObjectSize(roomObject.id, newSize);
    }, 20);
  }

  onShareScreenVideoSizeSet(args: { newSize: BoundingPosition; roomObject: RoomObject }): void {
    const { newSize, roomObject } = args;
    if (
      roomObject.position.x === newSize.x &&
      roomObject.position.y === newSize.y &&
      roomObject.size === newSize.height
    ) {
      return;
    }
    roomObject.position.x = newSize.x;
    roomObject.position.y = newSize.y;
    roomObject.size = newSize.height;
    this.videoSizeDebouncer.execute(() => {
      this.dataService.emitNewScreenShareVideoSize(roomObject.id, newSize);
    }, 20);
  }
  deleteObject(roomObject: RoomObject | DesktopRoomObject): void {
    if (roomObject instanceof DesktopRoomObject) {
      this.deleteShareScreen(roomObject as DesktopRoomObject);
    } else {
      this.deleteImage(roomObject);
    }
  }
  deleteImage(roomObject: RoomObject): void {
    this.dataService.emitDeleteImage(roomObject.id);
    const i = this.objects.indexOf(roomObject);
    if (i >= 0) {
      this.objects.splice(i, 1);
    }
  }
  deleteShareScreen(object: DesktopRoomObject): void {
    this.connectionManager?.stopScreenShareByRoomObject(object);
  }

  onFileUploadButtonClick(): void {
    this.isUploadImagePopupVisible = true;
  }

  leaveRoom(): void {
    this.leavePopupVisible = false;
    this.wholePagePopupMessage = 'またね！';
    this.showLoading();

    if (!this.connectionManager) {
      this.$router.push('/').catch(() => {});
    } else {
      this.connectionManager.destroy().catch(() => {});
      this.$router.push('/').catch(() => {});
    }
  }
  openBoardSetting(current?: RoomObject) {
    this.currentBoardRoomObject = current ?? null;
    this.isBoardSettingPopupVisible = true;
  }
  async onApplyBoardSetting(roomObject: RoomObject, imageFile: File | null, forceUpdate: boolean) {
    this.isBoardSettingPopupVisible = false;
    if (roomObject.roomType === 'all') {
      roomObject.roomId = this.room.id;
    } else {
      roomObject.roomId = this.currentSubRoomId;
      roomObject.roomType = this.currentSubRoomId === this.room.id ? 'room' : 'subroom';
    }
    if (imageFile) {
      const imageUrl = await uploadFile(this.dataService, 'map-image', imageFile);
      roomObject.imageBase64 = imageUrl;
    }
    if (this.currentBoardRoomObject || forceUpdate) {
      this.dataService.emitUpdateBoard(roomObject);
    } else {
      this.dataService.emitRegisterBoard(roomObject);
    }
  }
  requestSchedule(userId: string) {
    this.dataService.emitRequestSchedule(userId);
  }
  requestLock(roomObject: RoomObject | null) {
    if (roomObject) {
      this.dataService.emitRequestLock(roomObject.id);
    }
  }
  requestUnlock(roomObject: RoomObject | null) {
    if (roomObject) {
      this.dataService.emitRequestUnlock(roomObject.id);
    }
  }
  onChangeListCollapsed(collapsed: boolean) {
    this.isListCollapsed = collapsed;
    this.$nextTick().then(() => {
      this.setRoomContainer(true);
      zawaroom.iscroll.refresh();
    });
  }
  onChangeToolCollapsed(collapsed: boolean) {
    this.isToolCollapsed = collapsed;
    this.$nextTick().then(() => {
      this.setRoomContainer(true);
      zawaroom.iscroll.refresh();
    });
  }
  onChangeMessageToEditMode(ev: MouseEvent) {
    ev.stopPropagation();
    this.$store.commit('SetDefaultEditingMessage', '');
    this.$nextTick(() => {
      // すでに同じ文字が設定されている場合変更が通知されないので一度空白を追加して対応
      this.localIsEditingUserMessage = true;
      this.$store.commit('SetDefaultEditingMessage', this.userParticipantData?.userState.userMessage ?? '');
      this.resetMessageEditPositionByUser(ev);
    });
  }
  resetMessageEditPositionByUser(ev: MouseEvent) {
    const el = ev.target as HTMLElement;
    const rect = el.getBoundingClientRect();
    this.messageEditor.position.x = rect.x - 240 + rect.width + 10;
    this.messageEditor.position.y = rect.y;
  }
  resetMessageEditPositionByMenu() {
    const el: HTMLDivElement = this.$refs.roomContainer as HTMLDivElement;
    const rect = el.getBoundingClientRect();
    // オンになった場合は右は時に
    this.messageEditor.position.x = rect.width - 370;
    this.messageEditor.position.y = MAX_AVATAR_WIDTH_AND_HEIGHT;
  }
  moveLocalUserIcon(event: KeyboardEvent) {
    let pos = { x: this.userPosition.x, y: this.userPosition.y };
    switch (event.key) {
      case 'ArrowUp':
        pos.y -= 10;
        break;
      case 'ArrowDown':
        pos.y += 10;
        break;
      case 'ArrowLeft':
        pos.x -= 10;
        break;
      case 'ArrowRight':
        pos.x += 10;
        break;
    }
    pos = getCoordinatesPositionWithoutScale(
      pos,
      1,
      undefined,
      {
        x: 0,
        y: 0,
        width: this.room.roomSize.width - MAX_AVATAR_WIDTH_AND_HEIGHT,
        height: this.room.roomSize.height - MAX_AVATAR_WIDTH_AND_HEIGHT,
      }, // アイコンサイズ分小さい
    );
    this.onLocalVideoPositionChange(pos, false, false);
  }
  handleKeyDown(event: KeyboardEvent) {
    if (!this.$store.state.userProperties?.enableShortcut || this.isBoardSettingPopupVisible) {
      return;
    }
    const baseActions: { [key: string]: () => void } = {
      t: () => this.switchMessageEditorVisibility(),
      p: () => (this.isGeneralSettingsPopupVisible = true),
      a: () => this.openBoardSetting(),
      o: () => this.leaveRoom(),
      s: () => this.toggleShowStatusSelector(),
      g: () => this.onToggleShareScreen(),
      c: () => this.displayCenterOfScreenMyself(),
      f: () => this.openItemFusen(),
      k: () => this.openItemKanban(),
      i: () => this.openItemImage(),
    };
    const specialActions: { [key: string]: (ev: KeyboardEvent) => boolean } = {
      m: (ev) => {
        if (ev.ctrlKey && ev.shiftKey && !ev.altKey) {
          this.toggleLocalAudio();
          return true;
        }
        return false;
      },
      v: (ev) => {
        if (ev.altKey && !ev.ctrlKey && !ev.shiftKey) {
          this.toggleLocalVideo();
          return true;
        }
        return false;
      },
    };
    const arrowKeys = ['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'];
    if (this.isShowStatusSelector) {
      if (event.key === 'ArrowUp' && this.selectingIndex > 0) {
        this.selectingIndex--;
      } else if (event.key === 'ArrowDown' && this.selectingIndex < this.list.length - 1) {
        this.selectingIndex++;
      }
      if (event.key === 'Enter') {
        const selectedStatus = this.list[this.selectingIndex];
        this.isShowStatusSelector = false;
        this.dataService.emitStatus(selectedStatus.id);
      }
      if (event.key.toLowerCase() === 's') {
        this.toggleShowStatusSelector();
      }
    } else if (arrowKeys.includes(event.key)) {
      this.moveLocalUserIcon(event);
    } else if (!event.shiftKey && !event.ctrlKey && !event.altKey) {
      const action = baseActions[event.key.toLowerCase()];
      if (action) {
        event.preventDefault();
        action();
      }
    } else {
      const action = specialActions[event.key.toLowerCase()];
      if (action && action(event)) {
        event.preventDefault();
      }
    }
  }
  toggleShowStatusSelector(e?: Event) {
    if (e?.currentTarget as HTMLElement) {
      this.isFromToolsPanel = true;
    } else {
      this.isFromToolsPanel = false;
    }
    this.isShowStatusSelector = !this.isShowStatusSelector;
    if (this.isShowStatusSelector) {
      this.selectingIndex = this.currentStatusIndex;
    } else {
      this.selectingIndex = 0;
    }
  }
  closeStatusSelector() {
    this.isShowStatusSelector = false;
  }
  openItemFusen() {
    this.$store.commit('setBoardType', 'fusen');
    this.openBoardSetting();
  }
  openItemKanban() {
    this.$store.commit('setBoardType', 'message');
    this.openBoardSetting();
  }
  openItemImage() {
    this.$store.commit('setBoardType', 'image');
    this.openBoardSetting();
  }
  resetMessageEditPositionByMenuIfNeed() {
    const el = this.$refs.roomContainer as HTMLDivElement;
    if (!el || el.clientWidth === el.scrollWidth) {
      return;
    }
    this.resetMessageEditPositionByMenu();
  }
  onMessageEditPositionChange(args: { newPosition: CoordinatesPosition; roomObject: RoomObject }): void {
    const { roomObject, newPosition } = args;
    const x = Math.min(newPosition.x, this.roomContainer.htmlElementRef.clientWidth - 370);
    const y = Math.min(newPosition.y, this.roomContainer.htmlElementRef.clientHeight - 350);
    roomObject.position.x = x;
    roomObject.position.y = y;
  }
  switchMessageEditorVisibility() {
    this.$store.commit('SetIsShowEditor', !this.isShowEditor);
    this.$store.commit('SetDefaultEditingMessage', '');
  }
  async onMinimapClick() {
    const el = this.$refs.pip as PictureInPicture;
    if (!el) {
      return;
    }
    el.openPictureInPicture();
  }
  requestPipUpdateFrame() {
    const el = this.$refs.pip as PictureInPicture;
    if (!el) {
      return;
    }
    el.requestUpdateFrame();
  }
  onChangeStatus(s: StatusItem) {
    this.dataService.emitStatus(s.id);
  }

  onOpenLeavePopup() {
    this.leavePopupVisible = true;
  }
  onCancelLeaveRoom() {
    this.leavePopupVisible = false;
  }
  jumpLocalUserIcon(e: MouseEvent) {
    e.preventDefault();
    e.stopPropagation();
    const pointerPosition: CoordinatesPosition = getEventMouseOrTouchXY(e);
    const newXWithScale = pointerPosition.x - this.roomContainer.position.x - zawaroom.iscroll.x;
    const newYWithScale = pointerPosition.y - this.roomContainer.position.y - zawaroom.iscroll.y;
    const newPosition: CoordinatesPosition = {
      x: newXWithScale - (MAX_AVATAR_WIDTH_AND_HEIGHT / 2) * this.roomScale,
      y: newYWithScale - (MAX_AVATAR_WIDTH_AND_HEIGHT / 2) * this.roomScale,
    };
    const videoPositionWithoutScale: CoordinatesPosition = getCoordinatesPositionWithoutScale(
      newPosition,
      this.roomScale,
      undefined,
      {
        x: 0,
        y: 0,
        width: this.room.roomSize.width - MAX_AVATAR_WIDTH_AND_HEIGHT,
        height: this.room.roomSize.height - MAX_AVATAR_WIDTH_AND_HEIGHT,
      },
    );
    this.onLocalVideoPositionChange(videoPositionWithoutScale, false, true);
  }
}
